/**
 * 车辆油耗实体
 */
import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆油耗';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [carUlid, setCarUlid] = useState('');
    const [dealTime, setDealTime] = useState(currentDate);

    const [oilCardNumber, setOilCardNumber] = useState('');
    const [oilTypeNumber, setOilTypeNumber] = useState('');
    const [price, setPrice] = useState(0.00);
    const [quantity, setQuantity] = useState(0.00);
    const [amount, setAmount] = useState(0.00);
    const [oilAddress, setOilAddress] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setCarUlid('');
        setDealTime(currentDate);
        setOilCardNumber('');
        setOilTypeNumber('');
        setPrice(0.00);
        setQuantity(0.00);
        setAmount(0.00);
        setOilAddress('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setCarUlid(props.record.car_ulid);
            setDealTime(props.record.deal_time);
            setOilCardNumber(props.record.oil_card_number);
            setOilTypeNumber(props.record.oil_type_number);
            setPrice(props.record.price);
            setQuantity(props.record.quantity);
            setAmount(props.record.amount);
            setOilAddress(props.record.oil_address);
            setDescription(props.record.description);
        }
    }, [props.record]);

    const ok = () => {
        //  参数校验
        if (carUlid === '') {
            messageApi.error('车牌号码不能为空！');
            return;
        }
        if (oilCardNumber === '') {
            messageApi.error('加油卡号不能为空！');
            return;
        }
        if (oilTypeNumber === '') {
            messageApi.error('油品类型不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'car/oils' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'car_ulid': carUlid,
                'deal_time': dealTime,
                'oil_card_number': oilCardNumber,
                'oil_type_number': oilTypeNumber,
                'price': price,
                'quantity': quantity,
                'amount': amount,
                'oil_address': oilAddress,
                'description': description
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>{rff}加油车辆</Col>
                    <Col span={12} offset={1}>{rff}加油时间</Col>
                    <Col span={11}>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            value={carUlid}
                            onChange={(value) => setCarUlid(value)}
                            disabled={loading}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            <Option value=''>请选择车辆</Option>
                            {
                                props.carLists && props.carLists.map((item) => {
                                    return <Option key={item.key} value={item.key}>{item.license_number}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={12} offset={1}>
                        <DatePicker
                            showTime
                            placeholder='请选择日期'
                            onChange={(_, dateString) => setDealTime(dateString)}
                            value={dayjs(dealTime, 'YYYY-MM-DD hh:mm:ss')}
                            style={{ width: '100%' }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}加油卡号</Col>
                    <Col span={12} offset={1}>{rff}油品类型</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入'
                            value={oilCardNumber}
                            onChange={(e) => setOilCardNumber(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={12} offset={1}>
                        <Select
                            value={oilTypeNumber}
                            style={{ width: '100%' }}
                            onChange={(value) => setOilTypeNumber(value)}
                            disabled={loading}
                        >
                            <Option value=''>油品类型</Option>
                            {
                                CNF.oilTypeNumbers && CNF.oilTypeNumbers.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>实时单价</Col>
                    <Col span={12} offset={1}>加油数量</Col>
                    <Col span={11}>
                        <InputNumber
                            style={{ width: '100%' }}
                            suffix='元'
                            min={0}
                            step='0.01'
                            value={price}
                            onChange={(value) => {
                                setPrice(value);
                                setAmount(value * quantity);
                            }}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={12} offset={1}>
                        <InputNumber
                            style={{ width: '100%' }}
                            suffix='L'
                            min={0}
                            step='0.01'
                            value={quantity}
                            onChange={(value) => {
                                setQuantity(value);
                                setAmount(value * price);
                            }}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>加油金额</Col>
                    <Col span={24}>
                        <InputNumber
                            style={{ width: '100%' }}
                            suffix='元'
                            min={0}
                            step='0.01'
                            value={amount}
                            onChange={(value) => setAmount(value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>加油地址</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={oilAddress}
                            onChange={(e) => setOilAddress(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity